// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"35fba538","220":"8c184da5","322":"fa385da2","402":"eacebfdf","536":"80d4e123","548":"f620cde8","552":"e903b273","644":"17e1f8d2","766":"71080881","881":"3f5ae46c","967":"fa6b6b53","993":"0429c344"}[chunkId] + ".chunk.js";
};